import { writable } from 'svelte/store';

export const addSongCooldown = writable({
    show: false,
    duration: 0,
});
export const saySomethingCooldown = writable({
    show: false,
    duration: 0,
});

function show(timer, duration) {
    timer.set({
        show: true,
        duration: duration
    });
}

function hide(timer) {
    timer.set({
        show: false,
        duration: -1
    });
}

export function setAddSongCooldown(duration) {
    show(addSongCooldown, duration);
    setTimeout(() => {
        hide(addSongCooldown);
    }, duration);
}

export function setSaySomethingCooldown(duration) {
    show(saySomethingCooldown, duration);

    setTimeout(() => {
        hide(saySomethingCooldown);
    }, duration);
}